import { render, staticRenderFns } from "./PagePermission.vue?vue&type=template&id=55bd5ea0&scoped=true"
import script from "./PagePermission.vue?vue&type=script&lang=js"
export * from "./PagePermission.vue?vue&type=script&lang=js"
import style0 from "./PagePermission.vue?vue&type=style&index=0&id=55bd5ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd5ea0",
  null
  
)

export default component.exports